import * as React from "react";

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export default function useInterval(
    cb: () => void,
    delay: number | null,
    immediate = false,
): number | undefined {
    const savedCallback = React.useRef<() => void>(undefined);
    const [id, setId] = React.useState<number>();

    React.useEffect(() => {
        savedCallback.current = cb;
    }, [cb]);

    React.useEffect(() => {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }

        if (delay !== null) {
            if (immediate) {
                tick();
            }
            const nextId = window.setInterval(tick, delay);
            setId(nextId);
            return () => clearInterval(nextId);
        }
    }, [delay, immediate]);

    return id;
}
